import { fetchOrganization } from '../api';
import { useResource } from './useResource';

// Карточка организации и её настройки. Настройки здесь не косметические:
// со-подпись ответственного руководителя под сдачей рабочего места
// (ADR-005 §7) и оперативное согласование наряда (issue #445). Поэтому каждая
// показана словами о работе, а не названием поля — человек должен понимать,
// что именно эта строка меняет в наряде.

export function OrganizationSection({
  token,
  organizationId,
  onUnauthorized,
}: {
  token: string;
  organizationId: string;
  onUnauthorized: () => void;
}) {
  const organization = useResource(
    () => fetchOrganization(token, organizationId),
    onUnauthorized,
    [token, organizationId],
  );

  if (organization.loading) return <p className="section__note">Загружаю карточку…</p>;
  if (organization.error) return <p className="ui-error">{organization.error}</p>;
  const card = organization.data;
  if (!card) return null;

  return (
    <dl className="card">
      <dt>Название</dt>
      <dd>{card.name}</dd>
      <dt>Код</dt>
      <dd>{card.code}</dd>
      <dt>Состояние</dt>
      <dd>{card.isActive ? 'Действует' : 'Отключена'}</dd>
      <dt>Сдачу рабочего места подписывает и руководитель работ</dt>
      <dd>
        {card.closureHandoverRequiresManagerCoSignature ? 'Да' : 'Нет'}
        <span className="card__note">
          {card.closureHandoverRequiresManagerCoSignature
            ? ' — наряд с назначенным ответственным руководителем нельзя сдать без его подписи.'
            : ' — сдачу подписывает только производитель работ, как в бланке № 344.'}
        </span>
      </dd>
      <dt>Наряд согласуют перед допуском бригады</dt>
      <dd>
        {card.workOrderRequiresApproval ? 'Да' : 'Нет'}
        <span className="card__note">
          {card.workOrderRequiresApproval
            ? ' — бригаду нельзя допустить, пока наряд не согласует работник с правом согласования.'
            : ' — согласование не требуется, допуск оформляет допускающий сразу.'}
        </span>
      </dd>
    </dl>
  );
}
